import { SHOW_LOADER, HIDE_LOADER } from './constants'

export function showLoader(id, text = '') {
    return {
        type: SHOW_LOADER,
        data: {
            id,
            text,
        },
    }
}

export function hideLoader(id) {
    return {
        type: HIDE_LOADER,
        data: {
            id,
        },
    }
}
